import './instrument';
import './polyfill/dispose';
import './polyfill/intl-segmenter';
import './polyfill/promise-with-resolvers';
import './polyfill/request-idle-callback';
import '@pique/core/bootstrap/preload';

import { posthog } from '@pique/core/posthog';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';
import { bootstrapPico } from './pico-bootstrap';

function main() {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

try {
  main();
} catch (err) {
  console.error('Failed to bootstrap app', err);
  posthog.captureException(err instanceof Error ? err : new Error(String(err)), {
    context: 'app_bootstrap_error',
  });
}

void bootstrapPico().catch(err => {
  console.warn('pico bootstrap failed (non-fatal):', err);
});
